var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.option.hide),expression:"!option.hide"}],class:_vm.setClass(),style:(_vm.styleSize)},[_c('div',{style:(_vm.styleBorder)})])
}
var staticRenderFns = []

export { render, staticRenderFns }